import React from 'react';
import { ProductDetailRows } from './ProductDetailRows';
import { ServiceModel } from 'pco-product-service-internal-consumer';

type ProductDetailsBlockProps = { serviceModel: ServiceModel };

export const ProductDetailsBlock: React.FC<ProductDetailsBlockProps> = ({ serviceModel }) => {
  const detailItems = [
    {
      label: 'Engagement type',
      value: serviceModel?.engagementTypeName ?? '-',
      testId: 'product-detail-engagement-type',
    },
    {
      label: 'Service model',
      value: serviceModel?.serviceModelName ?? '-',
      testId: 'product-detail-service-model',
    },
    {
      label: 'Product',
      value: serviceModel.productDisplayName ?? '-',
      testId: 'product-detail-product-name',
    },
    {
      label: 'Product line',
      value: serviceModel?.productLineName ?? '-',
      testId: 'product-detail-product-line',
    },
    {
      label: 'Product implementation',
      value: serviceModel?.productImplementationName ?? '-',
      testId: 'product-detail-product-implementation',
    },
    {
      label: 'Investment strategy',
      value: serviceModel?.investmentStrategyName ?? '-',
      testId: 'product-detail-investment-strategy',
    },
    { label: 'Banking service package', value: '-', testId: 'product-detail-banking-service-package' },
    {
      label: 'Transaction fee model',
      value: serviceModel?.transactionFeeModelName ?? '-',
      testId: 'product-detail-transaction-fee',
    },
    { label: 'Currency', value: serviceModel?.currencyCode ?? '-', testId: 'product-detail-currency' },
  ];

  return <ProductDetailRows rows={detailItems} />;
};
